module.exports = __webpack_public_path__ + "img/ws2.7be1a1f4.jpg";